import React, { useState } from 'react';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { exportCompanyFinancials, exportTearSheet, exportPrimer, exportNewsEarnings } from '$/store/export/actions';
import { ReactComponent as ExportIcon } from '$/assets/icons/Export.svg';

import '../index.scss';

interface IExportDropDownProps {
  isLoading: boolean;
  currentCompany?: Bixby.Models.Company;
  error?: Bixby.Models.BixbyError;
  dispatchDownloadCompanyFinancials: (company: Bixby.Models.CompanyExport) => Promise<void>;
  dispatchDownloadTearSheet: (company: Bixby.Models.CompanyExport) => Promise<void>;
  dispatchDownloadPrimer: (company: Bixby.Models.CompanyExport) => Promise<void>;
  dispatchDownloadNews: (company?: Bixby.Models.CompanyExport) => Promise<void>;
}

const ExportDropDownCompanyClient: React.FC<IExportDropDownProps> = props => {
  const {
    currentCompany,
    dispatchDownloadCompanyFinancials,
    dispatchDownloadTearSheet,
    dispatchDownloadPrimer,
    dispatchDownloadNews,
  } = props;
  const [showOptions, setShowOptions] = useState(false);

  const toggleOptions = () => setShowOptions(!showOptions);

  const handleExport = (selectedOption: string) => {
    setShowOptions(false);

    if (!currentCompany) {
      return;
    }

    const companyExport: Bixby.Models.CompanyExport = {
      id: currentCompany.id,
      name: currentCompany.name,
      isDraft: currentCompany.isDraft,
    };

    switch (selectedOption) {
      case Bixby.Constants.EXPORT_FINANCIALMODEL:
        dispatchDownloadCompanyFinancials(companyExport);
        return;
      case Bixby.Constants.EXPORT_TEARSHEET:
        dispatchDownloadTearSheet(companyExport);
        return;
      case Bixby.Constants.EXPORT_PRIMER:
        dispatchDownloadPrimer(companyExport);
        return;
      case Bixby.Constants.EXPORT_NEWS:
        dispatchDownloadNews(companyExport);
        return;
    }
  };

  const exportActions = [Bixby.Constants.EXPORT_TEARSHEET, Bixby.Constants.EXPORT_PRIMER, Bixby.Constants.EXPORT_NEWS];

  if (currentCompany && !currentCompany.doesNotHaveFinancials) {
    exportActions.unshift(Bixby.Constants.EXPORT_FINANCIALMODEL);
  }

  return (
    <React.Fragment>
      <div onClick={toggleOptions} className="export_dropdown">
        <div className="export_icon">
          <ExportIcon />
        </div>
        Downloads
      </div>
      {showOptions && (
        <div className="export_options_menu">
          {exportActions.map(action => {
            return (
              <div className="export_option" key={action} onClick={() => handleExport(action)}>
                {action}
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.exportState.isLoading,
    error: state.exportState.error,
    currentCompany: state.portfolioState.currentCompany,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchDownloadNews: (company?: Bixby.Models.CompanyExport) => dispatch(exportNewsEarnings(company)),
  dispatchDownloadCompanyFinancials: (company: Bixby.Models.CompanyExport) =>
    dispatch(exportCompanyFinancials(company)),
  dispatchDownloadTearSheet: (company: Bixby.Models.CompanyExport) => dispatch(exportTearSheet(company)),
  dispatchDownloadPrimer: (company: Bixby.Models.CompanyExport) => dispatch(exportPrimer(company)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportDropDownCompanyClient);
